class dialog {
    constructor(htmlContent, width = 400, height = 400, product = false, height_to_content = false, show_close = true, with_background = true, padding_right = 0) {
        this.dialogElement = document.createElement('dialog');
        if (with_background) {
            this.dialogElement.classList.add('fl-dialog');
        }

        // Set the width or the max-width depending on the screen width
        const screenWidth = window.innerWidth;
        if (screenWidth < width) {
            this.dialogElement.style.maxWidth = screenWidth + 'px';
        } else if (width > 0) {
            this.dialogElement.style.width = width + 'px';
        }

        if (height > 0 && !height_to_content) {
            this.dialogElement.style.height = height + 'px';
        } else {
            this.dialogElement.style.height = 'fit-content';
        }

        if (padding_right > 0) {
            this.dialogElement.style.paddingRight = padding_right + 'px';
        }

        this.dialogElement.style.maxWidth = '800px';

        // Add the HTML content given as a parameter to the dialogElement
        this.dialogElement.innerHTML = htmlContent;

        if (show_close) {
            const dismissButton = document.createElement('button');
            dismissButton.classList.add('button-close');
            dismissButton.addEventListener('click', () => {
                this.close();
            });
            this.dialogElement.appendChild(dismissButton);
        }

        if (texts.managing) {
            const uploadButton = document.createElement('button');
            uploadButton.classList.add('button-upload');
            uploadButton.addEventListener('click', () => {
                var sp = new save_pics("container_3d");
                sp.cropping = false;
                sp.upload(product);
            });
            this.dialogElement.appendChild(uploadButton);

            const saveButton = document.createElement('button');
            saveButton.classList.add('button-save');
            saveButton.addEventListener('click', () => {
                var sp = new save_pics("container_3d");
                sp.save(save_pics.buildFileName(product.title));
            });
            this.dialogElement.appendChild(saveButton);
        }

        this.dialogElement.addEventListener('click', (event) => {
            // Check if the click is inside the dialogElement
            if (event.target === this.dialogElement) {
                this.close();
            }
        });

    }

    open() {
        document.getElementById('featherlight-configurator').appendChild(this.dialogElement);
        this.dialogElement.showModal();
    }

    close() {
        this.dialogElement.close();
        document.getElementById('featherlight-configurator').removeChild(this.dialogElement);
    }

    setPosition(x, y) {
        this.dialogElement.style.left = `${x - this.width / 2}px`;
        this.dialogElement.style.top = `${y - this.height / 2}px`;
    }
}
